import TileLayer from 'ol/layer/Tile';
import { OSM } from 'ol/source';
// import TileDebug from 'ol/source/TileDebug';
import WMTSTileGrid from 'ol/tilegrid/WMTS';
import WMTS from 'ol/source/WMTS';
import { getTopLeft } from 'ol/extent';
import Mercator from './mercator';
// import apiUrl from '../../api/all';

/**
 * Open street map 底圖
 * @param {object} lyrCfg 圖層設定
 * @param {boolean} visible 顯示與否
 */
export function Osm(lyrCfg, visible) {
    const osmSource = new OSM();
    const osm = new TileLayer({
        name: lyrCfg.type,
        visible,
        source: osmSource,
        opacity: 1,
    });
    return osm;
}

/*
 * 國土測繪中心「國土測繪圖資網路地圖服務系統」開放圖磚(WMTS)服務
 * http://gis.rchss.sinica.edu.tw/mapdap/?p=4061&lang=zh-tw
 * http://gis.rchss.sinica.edu.tw/mapdap/wp-content/uploads/2013/09/NLSC_WMTS.pdf
    {
        "B5000": "1/5000 基本地形圖",
        "EMAP1": "通用版電子地圖透明(含建物)",
        "EMAP2": "通用版電子地圖透明",
        "EMAP": "通用版電子地圖",
        "LANDSECT": "段籍圖",
        "LUIMAP": "國土利用調查成果圖",
        "PHOTO2": "正射影像圖(通用版)",
        "Village": "村里界"
    }
 * @param {string} name 圖層名稱，參照上面的清單
 * @param {boolean} visible 顯示與否
 * @param {string} type 底圖類型名稱
 * @param {boolean} isExport 是否為匯出頁面，是則使用 mapProxy
 * */
export function Nlsc(name, visible, type) {
    const projection = new Mercator();
    return new TileLayer({
        name: type,
        opacity: 1,
        visible,
        source: new WMTS({
            // url: isExport ? apiUrl.mapProxy : 'https://maps.nlsc.gov.tw/S_Maps/wmts',
            url: 'https://maps.nlsc.gov.tw/S_Maps/wmts',
            layer: name,
            matrixSet: projection.epsg,
            reprojectionErrorThreshold: 0.1,
            format: 'image/png',
            projection: projection.projection,
            tileGrid: new WMTSTileGrid({
                origin: getTopLeft(projection.projectionExtent),
                resolutions: projection.resolutions,
                matrixIds: projection.matrixIds,
            }),
            style: '_null',
        }),
    });
}
